import React from 'react';
import '../../styles/tokens.css';
import './shimmer.css';

type Props = {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
  radius?: number | string;
};

export const FrontShimmer: React.FC<Props> = ({
  width = '100%',
  height = 16,
  className = '',
  style,
  radius,
}) => (
  <div
    className={`ips-frontfw-shimmer ${className}`.trim()}
    style={{
      width,
      height,
      borderRadius: radius,
      ...style,
    }}
    aria-hidden="true"
  />
);
